import api from "./api";

export function findAll() {
  return new Promise((resolve, reject) => {
    api
      .get("/dra/next-index/custom")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deleteById(id) {
  return new Promise((resolve, reject) => {
    api
      .delete(`/dra/next-index/custom/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function save(data) {
  return new Promise((resolve, reject) => {
    api({
      method: "post",
      url: `/dra/next-index/custom`,
      data: data,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
